export enum ContactType_Enum
{
    None = 0,
    Email = 1,
    Text = 2,
    WhatsApp = 3
}